import i18n from "../../../../../constants/i18n";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import TagBadge from "../../../../../core/et3-shared-components/TagBadge";
import Et3Text from "../../../../../core/et3-text";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";

const ActiveFeaturesByFeatureSets = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const advancedStore = getUserAdvancedStore();
  const {
    isPaidSilver,
    isPaidGold,
    isPaidPlatinum,
    isPaidVIP,
    isPaidPower,
    isPaidBoost,
    isPaidRewind,
    isPaidPlus,
    isSubscribedBoost,
    isSubscribedRewind,
    isSubscribedVIP,
    isSubscribedSilver,
    isSubscribedGold,
    isSubscribedPlatinum,
    isSubscribedPower,
    isSubscribedPlus
  } = advancedStore.getUserSubscriptionStatus.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={0}
      height={36}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{ width: "100%" }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={350}
        height={36}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Text
          text={i18n.get("FEATURE_SET_ACTIVE_FEATURES")}
          fontFamily="MEDIUM"
          fontSize={14}
          color={colors.all.black}
          isSpan={true}
          style={{}}
        />
      </ET3Div>
      <TagBadge
        isPaid={
          isPaidVIP ||
          isPaidGold ||
          isPaidPlatinum ||
          isPaidPower ||
          isPaidBoost
        }
        tag={i18n.get("BOOST")}
        tagColor={
          isSubscribedVIP ||
          isSubscribedGold ||
          isSubscribedPlatinum ||
          isSubscribedPower ||
          isSubscribedBoost
            ? colors.all.vipGold
            : colors.all.gray
        }
        tagWidth={80}
      />
      <Et3Margin top={0} bottom={0} left={0} right={15} />
      <TagBadge
        isPaid={
          isPaidSilver ||
          isPaidGold ||
          isPaidPlatinum ||
          isPaidPower ||
          isPaidRewind
        }
        tag={i18n.get("REWIND")}
        tagColor={
          isSubscribedSilver ||
          isSubscribedGold ||
          isSubscribedPlatinum ||
          isSubscribedPower ||
          isSubscribedRewind
            ? colors.all.purple
            : colors.all.gray
        }
        tagWidth={90}
      />
      <Et3Margin top={0} bottom={0} left={0} right={15} />
      <TagBadge
        isPaid={isPaidGold || isPaidPlatinum || isPaidPower}
        tag={i18n.get("READ")}
        tagColor={
          isSubscribedGold || isSubscribedPlatinum || isSubscribedPower
            ? colors.all.powerPurple
            : colors.all.gray
        }
        tagWidth={80}
      />
      <Et3Margin top={0} bottom={0} left={0} right={15} />
      <TagBadge
        isPaid={isPaidGold || isPaidPlatinum}
        tag={i18n.get("CONVERSATION_BADGE")}
        tagColor={
          isSubscribedGold || isSubscribedPlatinum
            ? colors.all.darkOrange
            : colors.all.gray
        }
        tagWidth={120}
      />
      <Et3Margin top={0} bottom={0} left={0} right={15} />
      <TagBadge
        isPaid={isPaidSilver || isPaidGold || isPaidPlatinum || isPaidPlus}
        tag={i18n.get("LIKES")}
        tagColor={
          isSubscribedSilver ||
          isSubscribedGold ||
          isSubscribedPlatinum ||
          isSubscribedPlus
            ? colors.all.green
            : colors.all.gray
        }
        tagWidth={120}
      />
    </ET3Div>
  );
});

export default ActiveFeaturesByFeatureSets;
